/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_why_beaconauth_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Designed to bring everyone together. Secure, modern, and inclusive authentication for your community.`)
};

const zh_hans1_why_beaconauth_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旨在连接整个社区。为所有玩家提供安全、现代且包容的身份验证体验。`)
};

const zh_hant1_why_beaconauth_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旨在連結整個社群。為所有玩家提供安全、現代且包容的身分驗證體驗。`)
};

const fr_why_beaconauth_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conçu pour rassembler tout le monde. Une authentification sécurisée, moderne et inclusive pour votre communauté.`)
};

const de_why_beaconauth_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwickelt, um alle zusammenzubringen. Sichere, moderne und inklusive Authentifizierung für deine Community.`)
};

const ja_why_beaconauth_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`みんなをつなぐために設計。安全でモダン、そして誰にとっても使いやすい認証をコミュニティへ。`)
};

const ko_why_beaconauth_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모두를 하나로 모으기 위해 설계되었습니다. 커뮤니티를 위한 안전하고 현대적이며 포용적인 인증.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const why_beaconauth_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.why_beaconauth_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("why_beaconauth_desc", locale)
	if (locale === "en") return en_why_beaconauth_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_why_beaconauth_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_why_beaconauth_desc(inputs)
	if (locale === "fr") return fr_why_beaconauth_desc(inputs)
	if (locale === "de") return de_why_beaconauth_desc(inputs)
	if (locale === "ja") return ja_why_beaconauth_desc(inputs)
	return ko_why_beaconauth_desc(inputs)
};